import { colors } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { Platform, StyleSheet } from "react-native";

import { Box, Text } from "../../../../../../mads";
import { NewWindow } from "../../../../../../mads/icons";
import { useI18n } from "../../../../../../shared/I18n";
import { TextLink } from "../TextLink/TextLink";

const LINK_ICON_SIZE = 16;

// Custom icon component with better alignment
const AlignedNewWindowIcon = (props: any) => (
  <Box sx={styles.iconContainer}>
    <NewWindow {...props} />
  </Box>
);

export function CompanyNameSectionWithSubsidiaryInfo({
  companyName,
  companyOverviewLink,
  parentCompanyName,
  showRatings,
  isSimpleVjImproveActive,
  country,
}: {
  companyName: string;
  companyOverviewLink?: string;
  parentCompanyName: string;
  showRatings: boolean;
  isSimpleVjImproveActive: boolean;
  isCondensedRating: boolean;
  country: string;
}) {
  const i18n = useI18n();

  const opensInNewTab = i18n.gettext("opens in a new tab");
  const subsidiaryText = i18n.gettext(
    // # Text next to a company name to clarify it is a subsidiary of another company. {0} is a name of a parent company.
    "(part of {0})",
    [parentCompanyName],
  );

  if (!companyOverviewLink || !showRatings) {
    return (
      <Text level={3} sx={{ color: colors.foregroundStrong }}>
        {companyName} {subsidiaryText}
      </Text>
    );
  }

  if (country === "JP") {
    return (
      <>
        <Text level={2}>
          <TextLink variant="neutral" sx={styles.undecoratedLink} targetUrl={companyOverviewLink}>
            {companyName}
          </TextLink>
        </Text>
        <Text
          level={1}
          sx={
            isSimpleVjImproveActive
              ? { color: colors.foregroundWeak }
              : { color: colors.foregroundWeak, fontSize: 1 }
          }
        >
          {subsidiaryText}
        </Text>
      </>
    );
  }

  return (
    <Text>
      <TextLink
        inline
        iconAfter={<AlignedNewWindowIcon />}
        variant="strong"
        aria-label={`${companyName} (${opensInNewTab})`}
        targetUrl={companyOverviewLink}
      >
        {companyName}
      </TextLink>{" "}
      <Text level={3} sx={{ color: colors.foregroundStrong }}>
        {subsidiaryText}
      </Text>
    </Text>
  );
}

const styles = StyleSheet.create({
  undecoratedLink: {
    textDecorationLine: "none",
  },
  iconContainer: {
    position: "relative",
    transform: Platform.select({
      web: undefined,
      default: [{ translateY: -(LINK_ICON_SIZE / 6) }],
    }),
  },
});
